import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "page-not-found",
  class: "flex flex-column text-center mt-5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "404 - Page Not Found", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "You have backstrafed too far from any known url", -1)
const _hoisted_4 = { class: "cta-section flex mx-auto gap-4" }

import { useUserStore } from '../stores/UserStore';
import Button from 'primevue/button';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

function navigateTo(to: string){
  router.push(to);
}

const userStore = useUserStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        label: "Go to homepage",
        link: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('/')))
      }),
      (_unref(userStore).loaded && _unref(userStore).user)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            label: "Go to Base",
            link: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('/base')))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})